<script setup>
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import { api, currentGuild, inGuild, session } from '../api.js'

const { t } = useI18n()
const route = useRoute()
const url = ref(null)
let loadedFor = null

// 公会还没有飞书文档时按钮不出现；第一个任务建出文档后，下一次换页就会取到。
async function load() {
  if (currentGuild.slug === null || !session.loggedIn) { url.value = null; loadedFor = null; return }
  if (loadedFor === currentGuild.slug && url.value !== null) return
  const slug = currentGuild.slug
  const result = await api('GET', inGuild('/api/voko/work/sync-connections'))
  if (slug !== currentGuild.slug) return
  loadedFor = slug
  // 多份文档时取最早连上的那份（新任务默认进它）。
  url.value = result.connections.length === 0 ? null : result.connections[0].doc_url
}
watch([() => currentGuild.slug, () => session.loggedIn, () => route.path], () => { load().catch(() => { url.value = null }) }, { immediate: true })
</script>

<template>
  <a v-if="url !== null" class="doc-link" :href="url" target="_blank" rel="noopener noreferrer">{{ t('shell.feishuDoc') }}</a>
</template>

<style scoped>
.doc-link {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  padding: 0 var(--drama-space-md);
  border: 1px solid var(--drama-color-border);
  border-radius: var(--drama-radius-md);
  color: var(--drama-color-text);
  font-size: var(--drama-font-size-sm);
  text-decoration: none;
  white-space: nowrap;
}
.doc-link:hover { background: var(--drama-color-surface-alt); }
</style>
